"use strict";
var logo = document.querySelector(".logo");
var promise1 = new Promise(function(resolve, reject) {
    logo.addEventListener("click", function() {
        resolve();
    });
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(new Error("Timeout error"));
    }, 3000);
});
promise1.then(function() {
    return successHandler();
}).catch(function() {
    return errorHandler();
});
promise2.then(function() {
    return successHandler();
}).catch(function() {
    return errorHandler();
});
function successHandler() {
    var success = document.createElement("div");
    success.classList.add("message");
    success.textContent = "Promise was resolved!";
    document.body.append(success);
}
function errorHandler() {
    var error = document.createElement("div");
    error.classList.add("message", "error-message");
    error.textContent = "Promise was rejected!";
    document.body.append(error);
}

//# sourceMappingURL=index.66545018.js.map
